<template>
    <div class="min-bodyheight relative" ref="available">
        <canvas class="absolute bg-gray-100 dark:bg-black" ref="grid" v-cloak>Canvas cannot be used in this Browser Version</canvas>
        <canvas class="absolute bg-transparent" ref="sprites" v-cloak>Canvas cannot be used in this Browser Version</canvas>
        <canvas class="absolute bg-transparent" ref="board" v-cloak>Canvas cannot be used in this Browser Version</canvas>
        <canvas class="absolute bg-black bg-opacity-5 dark:bg-opacity-15" ref="players" v-cloak>Canvas cannot be used in this Browser Version</canvas>
        <canvas class="absolute bg-transparent" ref="mouseOverlay" v-cloak @mousemove="mouseMove" @click="selectCell">Canvas cannot be used in this Browser Version</canvas>
        <div class="absolute top-1 right-1 text-black dark:text-white">{{ mouseOverlay.gX + ',' + mouseOverlay.gY }}</div>
        <div class="absolute top-1 left-1">
            <div class="">
                <select v-model="sprites.selected">
                    <option value="next_tile">Next Tile: {{ nextTileNumber }}</option>
                    <option v-for="item in sprites.files">{{ item }}</option>
                </select>
                <button class="bg-blue-500 text-white p-1 ml-1 rounded" @click="saveBoard">SAVE</button>
            </div>
        </div>
    </div>
</template>

<script>
import solana from '../mixins/solana'
import axios from 'axios'

export default {
    name: 'GameConfig',
    props: ['isDark', 'account', 'gamesList', 'token', 'spritesList', 'spritesFiles'],
    mixins: [ solana ],
    data() {
        return {
            padding: 24,
            nextTileNumber: 0,
            width: 0,
            height: 0,
            nX: 0,
            nY: 0,
            s: 0,
            pL: 0,
            pR: 0,
            pT: 0,
            pB: 0,
            pX: 0,
            pY: 0,
            board: {
                context: null,
                data: null
            },
            grid: {
                context: null,
            },
            players: {
                context: null,
                list: [
                    {
                        cur: {x: 0, y: 0},
                        next: {x: 0, y: 0}
                    }
                ]
            },
            mouseOverlay: {
                context: null,
                x: 0,
                y: 0,
                gX: 0,
                gY: 0
            },
            sprites: {
                context: null,
                files: [],
                list: [],
                selected: 'next_tile'
            }
        }
    },
    async mounted() {
        window.addEventListener('resize', this.resizeEvent)
        this.grid.context = this.$refs.grid.getContext('2d')
        this.board.context = this.$refs.board.getContext('2d')
        this.sprites.context = this.$refs.sprites.getContext('2d')
        this.players.context = this.$refs.players.getContext('2d')
        this.mouseOverlay.context = this.$refs.mouseOverlay.getContext('2d')
        // Get board and sprites list
        await this.getBoard()
        this.resize()
        this.drawSprites()
        // this.drawBoard()
        this.nextTile()
    },
    unmounted() {
        window.removeEventListener('resize', this.resizeEvent)
    },
    watch: {
        isDark() {
            this.drawAll()
        },
        loading(value) {
            if (!value) {
                this.drawAll()
            }
        }
    },
    methods: {
        async getBoard() {
            this.sprites.list = this.spritesList
            this.sprites.files = this.spritesFiles
            await axios.get('/api/board').then((response) => {
                this.nX = response.data.board.width
                this.nY = response.data.board.height
                this.board.data = response.data.board.board ? response.data.board.board : []
            }).catch((err) => {
                console.log(err)
            })
        },
        async saveBoard() {
            const data = {
                'tiles': 100,
                'width': this.nX,
                'height': this.nY,
                'board': this.board.data
            }
            await axios.post('/api/board', data, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((response) => {
                this.$toast.success('Save successful.')
            }).catch((err) => {
                console.log(err)
            })
        },
        mouseMove(e) {
            let x = e.offsetX
            let y = e.offsetY
            let lastXcell = 0
            let lastYcell = 0
            let curXcell = 0
            let curYcell = 0
            if (x <= this.pL || y <= this.pT) {
                curXcell = 0
                curYcell = 0
            } else {
                for (let cellX = 0; cellX < this.nX; cellX++) {
                    curXcell = this.pL + (cellX * this.s)
                    if (x >= lastXcell && x <= curXcell) {
                        break
                    }
                    this.mouseOverlay.gX = cellX
                    lastXcell = curXcell
                }
                for (let cellY = 0; cellY < this.nY; cellY++) {
                    curYcell = this.pT + (cellY * this.s)
                    if (y >= lastYcell && y <= curYcell) {
                        break
                    }
                    this.mouseOverlay.gY = cellY
                    lastYcell = curYcell
                }
            }
            this.mouseOverlay.x = lastXcell
            this.mouseOverlay.y = lastYcell
            this.drawMouseOver()
        },
        nextTile() {
            this.nextTileNumber = this.board.data.filter((item) => {
                return item.hasOwnProperty('tile')
            }).length
        },
        selectCell(event) {
            this.nextTile();
            if (!this.sprites.selected && !event.ctrlKey && !event.metaKey) {
                return
            }
            for (let i = 0; i < this.board.data.length; i++) {
                if (this.board.data[i].x == this.mouseOverlay.gX && this.board.data[i].y == this.mouseOverlay.gY) {
                    if (event.ctrlKey || event.metaKey) {
                        if (this.board.data[i].sprites && this.board.data[i].sprites.length) {
                            this.board.data[i].sprites.pop()
                        }
                    } else {
                        if (!this.board.data[i].sprites) {
                            this.board.data[i].sprites = []
                        }
                        if (this.sprites.selected === 'next_tile') {
                            this.board.data[i]['tile'] = this.nextTileNumber
                        } else {
                            this.board.data[i].sprites.push(this.sprites.selected)
                        }
                    }
                    break
                }
            }
            this.drawBoard()
            this.drawSprites()
        },
        resizeEvent(e) {
            this.resize()
            this.drawAll()
        },
        resize() {
            const dpi = window.devicePixelRatio
            // dimensions
            this.width = this.$refs.available.offsetWidth
            this.height = this.$refs.available.offsetHeight
            this.s = Math.floor(Math.min((this.width - this.padding) / this.nX, (this.height - this.padding) / this.nY))
            // if (this.s < 20) {
            //     this.s = Math.floor((this.width - this.padding) / this.nX)
            //     console.log('s was < 20', this.s)
            // }
            this.pX = this.width - this.nX * this.s
            this.pY = this.nY * this.s
            if (this.pY >= this.height) {
                this.height = this.pY
            }
            this.pL = (this.width - (this.s * this.nX)) / 2
            this.pT = (this.height - (this.s * this.nY)) / 2
            this.pL = Number.isInteger(this.pL) ? this.pL : this.pL + 0.5
            this.pT = Number.isInteger(this.pT) ? this.pT : this.pT + 0.5
            this.pR = this.width - this.nX * this.s - this.pL
            this.pB = this.height - this.nY * this.s - this.pT
            // board layer
            this.$refs.board.width = this.width * dpi
            this.$refs.board.height = this.height * dpi
            this.$refs.board.style.width = this.width + 'px'
            this.$refs.board.style.height = this.height + 'px'
            this.board.context.scale(dpi, dpi)
            this.board.context.imageSmoothingEnabled = false
            // grid layer
            this.$refs.grid.width = this.width * dpi
            this.$refs.grid.height = this.height * dpi
            this.$refs.grid.style.width = this.width + 'px'
            this.$refs.grid.style.height = this.height + 'px'
            this.grid.context.scale(dpi, dpi)
            this.grid.context.imageSmoothingEnabled = false
            // sprites layer
            this.$refs.sprites.width = this.width * dpi
            this.$refs.sprites.height = this.height * dpi
            this.$refs.sprites.style.width = this.width + 'px'
            this.$refs.sprites.style.height = this.height + 'px'
            this.sprites.context.scale(dpi, dpi)
            this.sprites.context.imageSmoothingEnabled = false
            // players layer
            this.$refs.players.width = this.width * dpi
            this.$refs.players.height = this.height * dpi
            this.$refs.players.style.width = this.width + 'px'
            this.$refs.players.style.height = this.height + 'px'
            this.players.context.scale(dpi, dpi)
            this.players.context.imageSmoothingEnabled = false
            // mouseOverlay layer
            this.$refs.mouseOverlay.width = this.width * dpi
            this.$refs.mouseOverlay.height = this.height * dpi
            this.$refs.mouseOverlay.style.width = this.width + 'px'
            this.$refs.mouseOverlay.style.height = this.height + 'px'
            this.mouseOverlay.context.scale(dpi, dpi)
            this.mouseOverlay.context.imageSmoothingEnabled = false
        },
        drawAll() {
            // this.drawGrid()
            // this.drawGridCoords()
            // this.drawBoard()
            this.drawSprites()
        },
        drawGrid() {
            this.grid.context.clearRect(0, 0, this.width, this.height)
            this.grid.context.strokeStyle = this.isDark ? '#333333' : '#dddddd'
            this.grid.context.beginPath()
            for (let x = this.pL; x <= this.width; x += this.s) {
                this.grid.context.moveTo(x, this.pT)
                this.grid.context.lineTo(x, this.height - this.pB)
            }
            for (let y = this.pT; y <= this.height; y += this.s) {
                this.grid.context.moveTo(this.pL, y)
                this.grid.context.lineTo(this.width - this.pR, y)
            }
            this.grid.context.stroke()
        },
        drawGridCoords() {
            // coordinates
            let fontSize = (this.s / 3)
            this.grid.context.font = fontSize + 'px monospace'
            this.grid.context.fillStyle = 'red'
            this.grid.context.textAlign = 'center'
            this.grid.context.textBaseline = 'middle'
            for (let x = 0; x < this.nX; x++) {
                for (let y = 0; y < this.nY; y++) {
                    this.grid.context.fillText(x + ',' + y, this.pL + (x * this.s) + (this.s / 2), this.pT + (y * this.s) + (this.s / 2))
                }
            }
        },
        drawBoard() {
            this.board.context.clearRect(0, 0, this.width, this.height)
            for (let i = 0; i < this.board.data.length; i++) {
                if (this.board.data[i].hasOwnProperty('tile')) {
                    this.drawBoardCell(this.board.data[i].x, this.board.data[i].y, this.board.data[i].tile)
                }
            }
        },
        drawBoardCell(x, y, text) {
            let color = this.isDark ? '#222' : '#ddd'
            this.board.context.strokeStyle = color
            this.board.context.beginPath()
            this.board.context.rect(this.pL + (x * this.s), this.pT + (y * this.s), this.s, this.s)
            this.board.context.stroke()
            let fontSize = 10
            this.board.context.font = fontSize + 'px arial'
            this.board.context.fillStyle = this.isDark ? '#000' : '#FFF'
            this.board.context.textAlign = 'center'
            this.board.context.textBaseline = 'middle'
            this.board.context.fillText(text, this.pL + (x * this.s) + (this.s / 2), this.pT + (y * this.s) + (this.s / 2))
        },
        drawSprites() {
            this.sprites.context.clearRect(0, 0, this.width, this.height)
            for (let i = 0; i < this.board.data.length; i++) {
                if (this.board.data[i].sprites && this.board.data[i].sprites.length) {
                    for (let index = 0; index < this.board.data[i].sprites.length; index++) {
                        let sprite = this.board.data[i].sprites[index]
                        this.drawSprite(this.board.data[i].x, this.board.data[i].y, this.sprites.list[sprite])
                    }
                }
            }
        },
        drawSprite(x, y, imageSrc = null) {
            if (imageSrc !== null) {
                this.sprites.context.drawImage(imageSrc, this.pL + (x * this.s), this.pT + (y * this.s), this.s, this.s)
            } else {
                this.sprites.context.clearRect(this.pL + (x * this.s), this.pT + (y * this.s), this.s, this.s)
            }
        },
        drawMouseOver() {
            this.mouseOverlay.context.clearRect(0, 0, this.width, this.height)
            if (this.mouseOverlay.x != 0 && this.mouseOverlay.y != 0) {
                this.mouseOverlay.context.fillStyle = 'rgba(255, 0, 0, 0.5)'
                this.mouseOverlay.context.fillRect(this.mouseOverlay.x, this.mouseOverlay.y, this.s, this.s)
            }
        }
    }
}
</script>
